import PropTypes from 'prop-types';

export const user = PropTypes.shape({
  is_customer: PropTypes.bool.isRequired,
  last_name: PropTypes.string.isRequired,
  first_name: PropTypes.string.isRequired,
  is_staff: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired
});

export const auth = PropTypes.shape({
  user,
});


// WEBPACK FOOTER //
// ./src/api/users/types.js